import Colors from "assets/Colors";
import PieChartCustom from "components/common/PieChart";
import AlertIcon from "components/icons/AlertIcon";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useBusinessContext } from "../../../BusinessApp";

function MoneyLine({ color, text, money, last }) {
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{money || 0}</s.Money>
    </s.MoneyLine>
  );
}

function PieChartTaxes({ orderTaxes, loading, firstGraph }) {
  const { t } = useTranslation();
  const { currencyFormat } = useBusinessContext();

  return (
    <s.Container ref={firstGraph}>
      <s.Title>
        {t("components.InformTaxesReport.PieChartTaxes.moreAppliedTaxes")}
      </s.Title>
      {loading ? (
        <Loading height="417px" size="middle" />
      ) : (
        <>
          <div style={{ width: "140px", margin: "0 auto 40px " }}>
            {orderTaxes?.length > 0 ? (
              <PieChartCustom
                data={orderTaxes.map((item, i) => ({
                  name: item.name,
                  value: parseFloat(item.total),
                  color:
                    i === 0
                      ? Colors.text_on_primary
                      : i === 1
                      ? `${Colors.primary_web}100`
                      : `${Colors.primary_web}90`,

                  background:
                    i === 0
                      ? `${Colors.primary_web}`
                      : i === 1
                      ? `${Colors.primary_web_color1}90`
                      : i === 2
                      ? `${Colors.primary_web_color1}40`
                      : i === 3
                      ? `${Colors.primary_web_color1}15`
                      : `${Colors.primary_web_color2}5`,
                }))}
              />
            ) : (
              <s.NoItemsContainer>
                <s.NoItemsMessageCenter>
                  <AlertIcon
                    style={{ display: "block", marginBottom: "7px" }}
                  />
                  {t("components.InformTaxesReport.PieChartTaxes.noData")}
                </s.NoItemsMessageCenter>
              </s.NoItemsContainer>
            )}
          </div>

          {orderTaxes.map((item, i) => (
            <MoneyLine
              key={i}
              color={
                i === 0
                  ? `${Colors.primary_web}`
                  : i === 1
                  ? `${Colors.primary_web_color1}90`
                  : i === 2
                  ? `${Colors.primary_web_color1}40`
                  : i === 3
                  ? `${Colors.primary_web_color2}15`
                  : `${Colors.primary_web_color2}5`
              }
              text={item.name}
              money={currencyFormat(item.total)}
            />
          ))}
        </>
      )}
    </s.Container>
  );
}

export default PieChartTaxes;
